/**
 * Generate a URL-friendly slug from a product name (supports Hebrew).
 * Replaces spaces with hyphens and encodes for safe URL usage.
 */
export function productSlug(name: string): string {
  const safeName = typeof name === 'string' ? name : String(name ?? '');
  return encodeURIComponent(safeName.trim().replace(/\s+/g, "-"));
}

/**
 * Build the canonical product URL from a product name.
 */
export function productUrl(name: string): string {
  return `/מוצר/${productSlug(name)}`;
}

/**
 * Decode a URL slug back to the original product name for DB lookup.
 */
export function decodeProductSlug(slug: string): string {
  return decodeURIComponent(slug).replace(/-/g, " ");
}
